module.exports = __webpack_public_path__ + "static/media/ic-mini-play.0ae77a31.svg";